import { useNavigate } from "react-router-dom";

const images = [
  "1.jpg",
  "2.jpg",
  "3.jpg",
  "4.jpg",
  "5.jpg",
  "6.jpg",
  "7.jpg",
  "8.jpg",
  "9.jpg",
  "10.jpg",
  "11.jpg",
  "12.jpg",
  "13.jpg",
  "14.jpg",
  "15.jpg",
  "16.jpg",
  "17.jpg",
  "18.jpg",
  "19.jpg",
  "20.jpg",
  "21.jpg",
  "22.jpg",
  "23.jpg",
  "24.jpg",
  "25.jpg",
  "26.jpg",
  "27.jpg",
  "28.jpg",
  "29.jpg",
  "30.jpg",
  "31.jpg",
  "32.jpg",
  "33.jpg",
  "34.jpg",
  "35.jpg",
  "36.jpg",
  "37.jpg",
  "38.jpg",
  "39.jpg",
  "40.jpg",
  "41.jpg",
  "42.jpg",
];

export default function GreciaPage() {
  const navigate = useNavigate();

  function PhotoGrid({ images, folder }) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {images.map((img, idx) => (
          <div
            key={img}
            className="aspect-square overflow-hidden rounded-lg shadow-lg bg-white flex items-center justify-center hover:scale-105 transition-transform duration-200"
          >
            <img
              src={`/proiecte/Erasmus+/pozeGrecia/${img}`}
              alt={`Grecia Erasmus ${idx + 1}`}
              className="object-cover w-full h-full"
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-4 text-center">
          Întâlnire de lucru in KATERINI, GRECIA în cadrul proiectului Erasmus+
          KA229 “OUR PAST OUR FUTURE “
        </h1>
        <p className="mb-4">
          Întorși din Țara lui Aristotel, reprezentanţii Liceului Tehnologic
          „Dr. Florian Ulmeanu” Ulmeni: prof. Scurtu Cosette-coordonatorul
          proiectului, prof. Dan Mariana, prof. Mos Amalia, Pop Iulia cls. a
          VIII-a A, Koncz Izolda cls. a VIII-a A, Koncz Andrea cls. a VIII-a A,
          Sima Laurentiu a XII-a, Homorodan Catalin cls. a XII-a, Koncz Banjamin
          cls. a XII-a, Morar Mihai cls. a XII-a, au participat în perioada 8
          -15 decembrie 2019 la prima activitate de învăţare-predare din cadrul
          proiectului ,, OUR PAST OUR FUTURE”, parteneriat strategic în domeniul
          educational din cadrul Acţiunii cheie KA229, numar de identificare
          2019-1-IT02-KA229-062420_5, realizat cu sprijinul financiar al
          Comisiei Europene prin ANPCDEFP.
        </p>
        <p className="mb-4">
          Proiectul se desfăşoară pe o perioadă de 2 ani (2019 –2021), fiind un
          parteneriat între cinci scoli din tari diferite precum: Italia,
          România, Letonia, Turcia si Grecia, (țara gazdă a acestei întâlniri).
        </p>
        <p className="mb-4">
          Topicul propus de partenerii greci a vizat Muntele Olimp, ca monument
          natural, sit cu interes si valoare ecologica, istorica, arheologica și
          mitologică. Acest program promoveaza competentele cheie la nivel
          international in ceea ce priveste potentialul economic, atragerea
          turiștilor, precum și creșterea nivelului de trai.
        </p>
        <p className="mb-2 font-semibold">Școlile participante:</p>
        <ul className="list-disc ml-6 mb-4">
          <li>Instituto D'istruzione Superiore E.Fermi-G. Filangieri Italy</li>
          <li>Dr.Kemal Naci Eksi Anadolu Lisesi Turkey</li>
          <li>3o Geniko Lykeio Katerinis Greece</li>
          <li>Rezekne State Gymnasium No1 Latvia</li>
          <li>
            Liceul Tehnologic” Dr. Florian Ulmeanu”, Ulmeni, Maramures, România
          </li>
        </ul>
        <p className="mb-4">
          În prima zi a reuniunii a fost prezentat programul de activități
          pentru toată perioada. În cadrul proiectului, pe parcursul a cinci
          zile, au avut loc activități de predare – învățare, precum si
          workshop-uri (business game -uri). Ceremonia de bun venit a avut loc
          în data de 8-15/12/2019, in KATERINI, GRECIA.
        </p>
        <p className="mb-4">
          In fiecare zi s-a desfasurat jocul de afaceri in care elevii au lucrat
          împreună, fiind impartiti pe doua grupe mixte, pentru realizarea
          companiilor propuse de tara gazda:
        </p>
        <ul className="list-disc ml-6 mb-4">
          <li>
            Grupa A: “A wellness and cultural center based at the broader area
            of Mt Olympus”
          </li>
          <li>
            Grupa B: “A mythological and historical park near a village in the
            broader area of Olympus”.
          </li>
        </ul>
        <p className="mb-4">
          O altă activitate inclusă în program a fost lexiconul, unde elevii si
          profesorii participanti au invatat cuvinte in limba tarii gazda. A
          avut loc o întâlnire cu oficialitățile orașului, unde ni s-a explicat
          implicarea acestora în școală, susținerea învățământului, a elevilor
          și a profesorilor.
        </p>
        <p className="mb-4">
          În ultima zi dedicată primei întâlniri din cadrul proiectului, s-a
          desfașurat prezentarea finală a business game-ului, precum și
          festivitatea de premiere. Limba de comunicare pe toata durata
          desfasurarii activitatilor a fost limba engleză.
        </p>
        <p className="mb-4">
          Profesorii participanți au avut ședințe de proiect în care au analizat
          în ce măsură au fost atinse obiectivele stabilite până la această
          etapă a proiectului și au prezentat sarcinile pentru următoarea
          mobilitate care va avea loc în Romania.
        </p>
        <p className="mb-4">
          Pe lângă activitățile de antreprenoriat s-au desfășurat și excursii
          tematice care au fost foarte apreciate de către participanți.
          Întâlnirea a fost una fructuoasă, realizându-se toate obiectivele
          propuse pentru această etapă a proiectului.
        </p>
        <p className="mb-4">
          Eleva Pop Iulia afirma: "Dacă ar fi să vorbesc despre ce mi-a plăcut
          mai mult, nu cred ca aș putea alege doar una dintre experiențe. Am
          fost fascinată atunci cand am vizitat mormintele lui Filip al doilea
          si pe cel al fiului, lui Alexandru cel Mare, m-a impresionat nespus
          satul de munte PANTELEIMONAS din regiunea PIERIA"
        </p>
        <p className="mb-4">
          Un alt participant, Cătălin Homorodan, susține că: "Experiența trăită
          în Grecia a fost cel mai bun, extraordinar și minunat lucru care mi se
          putea intâmpla.” Astfel, ERASMUS+ înseamnă prietenie, provocare,
          oameni și curajul de a pleca spre noi orizonturi.
        </p>
        <PhotoGrid
          images={images}
          folder="proiecte/erasmus+/pozeGrecia"
          altPrefix="Grecia Erasmus"
        />
        <button
          onClick={() => navigate("/proiecte/erasmus+")}
          className="m-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 float-right"
        >
          &larr; Înapoi
        </button>
      </main>
    </div>
  );
}
